import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className="w-100" src="./image/404.jpg" alt="" />
        </div>
    );
};

export default NotFound;